module.exports = __webpack_public_path__ + "img/ico_logout.bec90baa.svg";